import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "reactstrap";
import { LoadingMessage } from "../Precheck/Precheck";
import { Number } from "../Precheck/Details";
import style from "./Footer.module.scss";
import { FormattedDate } from "react-intl";

const OrderTotals = ({ fetchTotals, orderId, decimalScale }) => {
  const [values, setValues] = useState(null);

  useEffect(() => {
    fetchTotals({ orderId }).then((r) => {
      const {
        OrderAVPrice,
        OrderAVClientPrice,
        OrderTotalExecuted,
        OrderFutureSettlmentDate,
        precheck,
        AvgNominalRate,
        AvgXIRR,
      } = r.response;

      setValues({
        avg: OrderAVPrice,
        avgWithMarkup: OrderAVClientPrice,
        total: OrderTotalExecuted,
        settleDate: OrderFutureSettlmentDate,
        avgNominalRate: AvgNominalRate,
        avgXIRR: AvgXIRR,
        precheck,
      });
    });
  }, [fetchTotals, orderId]);

  if (values == null) {
    return (
      <div className={style.totalsLoading}>
        <LoadingMessage text={"Retrieving totals"} style={{ justifyContent: "center", padding: 0 }} />
      </div>
    );
  }

  return (
    <div className={style.totals}>
      <Container>
        <Row>
          <Col lg={6}>
            <table>
              <tbody>
                <tr>
                  <td>Total executed</td>
                  <td>
                    <Number value={values.total} dataTypeDecimalName="currency" />
                  </td>
                </tr>
                <tr>
                  <td>Avg. price</td>
                  <td>
                    <Number value={values.avg} decimalScale={decimalScale} dataTypeDecimalName="price" />
                  </td>
                </tr>
                <tr>
                  <td>Avg. price w/markup</td>
                  <td>
                    <Number
                      value={values.avgWithMarkup}
                      decimalScale={decimalScale}
                      dataTypeDecimalName="price"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Sett. Date</td>

                  <td>
                    <FormattedDate value={values.settleDate + "T00:00"} />
                  </td>
                </tr>
                <tr>
                  <td>Avg. Nominal Rate</td>
                  <td>
                    <Number value={values.avgNominalRate} dataTypeDecimalName="currency" />
                  </td>
                </tr>
                <tr>
                  <td>Accrual</td>
                  <td>
                    <Number value={values.precheck.Accrual} dataTypeDecimalName="currency" />
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
          <Col lg={6}>
            <table>
              <tbody>
                <tr>
                  <td>Principal</td>
                  <td>
                    <Number value={values.precheck.Principal} dataTypeDecimalName="currency" />
                  </td>
                </tr>
                <tr>
                  <td>UpFront</td>
                  <td>
                    <Number value={values.precheck.upfront} dataTypeDecimalName="currency" />
                  </td>
                </tr>

                {values &&
                  values.precheck &&
                  (values.precheck.commission && values.precheck.commission > 0 ? (
                    <tr>
                      <td>Commission</td>
                      <td>
                        <Number value={values.precheck.commission} dataTypeDecimalName="currency" />
                      </td>
                    </tr>
                  ) : values.precheck.charge && values.precheck.charge > 0 ? (
                    <tr>
                      <td>Charge</td>
                      <td>
                        <Number value={values.precheck.charge} dataTypeDecimalName="currency" />
                      </td>
                    </tr>
                  ) : null)}

                <tr>
                  <td>TAX</td>
                  <td>
                    <Number value={values.precheck.tax} dataTypeDecimalName="currency" />
                  </td>
                </tr>
                <tr>
                  <td>Avg. XIRR</td>
                  <td>
                    <Number value={values.avgXIRR} dataTypeDecimalName="currency" />
                  </td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td>
                    <Number value={values.precheck.Total} dataTypeDecimalName="currency" />
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default OrderTotals;
